import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Logging } from './LoadingComponent';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
  }
};

class Home extends Component {
    render(){
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else {
        return(
            <div className='container'>
                <div className="row align-items-center">
                    <div className="col-12">
                        <img src={require('../shared/SUR_Quantim_HWeb_Positivo.png')} alt={"quantIM"} width="70%"/>
                    </div>
                </div>

            </div>
        );
      }
    }
}

export default connect(mapStateToProps)(Home);
